import optionTypes from 'src/js/modules/blocks/constants/display-options-type';
import convertChangedOptionToOperation from './convert-changed-option-to-operation';
import { SURFACES_ATTRIBUTE } from '../constants/display-options';
import { BACKGROUND_HIDDEN_ATTRIBUTE } from '../constants/block-background-attributes';
import isOverlayTouched from '../verifiers/is-overlay-touched';

const getAttributesOperations = (element, changedOptions, displayOptions) => {
  const operations = changedOptions.reduce((accOperations, option) => {
    let operation = convertChangedOptionToOperation(option, element);

    if (!operation) {
      return accOperations;
    }

    const optionWithSameAttribute = displayOptions.find(
      ({ attribute, id }) =>
        option.attribute === attribute && option.id !== id && option.type !== optionTypes.SURFACE
    );

    if (optionWithSameAttribute) {
      operation = {
        ...operation,
        value: `${operation.value} ${optionWithSameAttribute.value}`,
      };
    }

    const isOperationAlreadyExists = accOperations.some(
      (accOperation) =>
        accOperation.name === operation.name &&
        accOperation.elementId === operation.elementId &&
        accOperation.operation === operation.operation
    );

    if (isOperationAlreadyExists) {
      return accOperations;
    }

    if (
      [SURFACES_ATTRIBUTE, BACKGROUND_HIDDEN_ATTRIBUTE].includes(option.attribute) &&
      isOverlayTouched(displayOptions)
    ) {
      operation = {
        ...operation,
        options: {
          skipDesignAutomation: true,
        },
      };
    }

    return [...accOperations, operation];
  }, []);

  return [...operations];
};

export default getAttributesOperations;
